export default __webpack_public_path__ + "static/media/mb_pro_main_home.e5c5f28c.png";